exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navi-button{color:#fff}#naviCont .ant-input-affix-wrapper .ant-input{background-color:#3587eb;border:0;color:#e1f1ff}#naviCont .ant-input-affix-wrapper .ant-input::-webkit-input-placeholder{color:#e1f1ff}#naviCont .ant-input-affix-wrapper .ant-input::-moz-placeholder{color:#e1f1ff}#naviCont .navi-setting{background-color:#559ffb;color:#fff;border:0;margin:10px 0}", ""]);

// exports
